import { render } from "./RuleEditorModal.vue?vue&type=template&id=3c04e6f2&scoped=true"
import script from "./RuleEditorModal.vue?vue&type=script&lang=js"
export * from "./RuleEditorModal.vue?vue&type=script&lang=js"

import "./RuleEditorModal.vue?vue&type=style&index=0&id=3c04e6f2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3c04e6f2"

export default script